
import { contains, forEachObjIndexed, is, toLower, toUpper, pipe, toPairs, map, join} from 'ramda';
import logerGetter from '../utils/logger';

let baseUrl = process.env.URL_ENVIRONMENT;

export const langCodeCorrector = langCode => {
  switch (toUpper(langCode)) {
    case 'AL':
      langCode = 'de';
      break;
    case 'CN':
      langCode = 'zi';
      break;
    case 'CZ':
      langCode = 'cs';
      break;
    default:
      break;
  }
  return toLower(langCode);
};

export const momentLangCodes = (lang) => {
  switch (toUpper(lang)) {
    case 'ZI':
      return 'zh_cn';
    case 'EN':
      return 'en_ie';
    case 'AR':
      return 'ar_ma';
    default:
      return lang;
  }
};

export const toIsoLangCode = langCode => {
  switch (toUpper(langCode)) {
    case 'AL':
      langCode = 'de';
      break;
    case 'ZI':
      langCode = 'cn';
      break;
    case 'CZ':
      langCode = 'cs';
      break;
    default:
      break;
  }
  return toLower(langCode);
};

let lang = 'es';
export const setHeaderLang = baseLang => {
  lang = langCodeCorrector(baseLang) || lang;
};

class QueryService {
  constructor(context) {
    this.baseUrl = baseUrl;
    this.context = context || 'hotels';
    this.store = {};
  }

  get(config, params, hotels, headers = null, store) {
    let fullFiled, path;
    if(is(Object, config)){
      path = config.path;
      params = config.params;
      hotels = config.contextId;
      headers = config.headers;
      store = config.store;
      fullFiled = config.fullFiled;
    } else {
      path = config;
    }
    
    return this.contextualizer('GET', path, hotels, params, null, headers, store, fullFiled);
  }

  put(path, body, hotels, headers = null) {
    return this.contextualizer('PUT', path, hotels, null, body, headers);
  }

  post(path, body, hotels, headers = null) {
    return this.contextualizer('POST', path, hotels, null, body, headers);
  }

  patch(config, body, hotels, headers = null, store, fullFiled) {
    let path,params;
    if(is(Object, config)){
      path = config.path;
      params = config.params;
      hotels = config.contextId;
      headers = config.headers;
      store = config.store;
      fullFiled = config.fullFiled;
      body = config.body;
    } else {
      path = config;
    }
    return this.contextualizer('PATCH', path, hotels, params, body, headers, store, fullFiled);
  }

  delete(path, hotels, headers = null) {
    return this.contextualizer('DELETE', path, hotels, null, null, headers);
  }

  query(method, contextId, path, params = null, body = null, headers = null) {
    const currentConfig = {
      headers: new Headers({
        Connection: 'keep-alive',
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        //"Authorization": "Basic YmlnYm9zc0BpZ213ZWIuY29tOlM3Y2NEaVhTNFlBVDBkeUR6bmkyZGM4OGQzVEJWVzFsakJjajdSVHNfNDF2M3d6c3NkdEhHZTlLMk1LSEEtOWFacnRxSEQ0X0Jxd3BldDR0RHhSWmhB",
        'Accept-Language': lang,
        'Accept-Encoding': 'gzip, deflate'
      }),
      //mode: 'no-cors',
      cache: 'default',
      method: 'GET'
    };

    currentConfig.method = method;
    headers &&
    headers.length > 0 &&
    headers.forEach(header => {
      const key = Object.keys(header)[0];
      currentConfig.headers.set(key, header[key]);
    });
    const url = new URL(
      '/api/' + (contextId ? this.context + '/' + contextId + '/' : '') + path + (params ? '?' + params : ''),
      this.baseUrl
    );

    if (body) {
      currentConfig.body = JSON.stringify(body);
    }

    const requestPromise = new Promise((resolve, reject) => {
      fetch(url, currentConfig)
        .then(response => {
          if (response.ok) {
            resolve(response.json());
          } else {
            if (response.status === 409) {
              const availError = new Error();
              availError.name = 409;
              availError.message = response.statusText;
              reject(availError);
              return;
            }
            resolve({ success: response.ok, code: response.code });
          }
        })
        .catch(err => {
          if (contextId && !contains('send_avail_error', url)) {
            const logger = logerGetter(contextId);
            const error = err && err instanceof Error ? err.toString() : JSON.stringify(err);
            const info = body
              ? { url: method + ' ' + url, body, err: error }
              : {
                url: method + ' ' + url,
                err: error
              };
            logger.sendMail('error in api', info, true);
          }
          reject(Error(err));
        });
    });
    
    requestPromise.preventAction = requestPromise.then;
    return requestPromise;
  }

  contextualizer(method, path, contextId, params=null, body=null, headers=null, store=null, fullFiled=null) {
    const storeData = fullFiled && fullFiled();
    if (storeData) {
      const promiseData = Promise.resolve(storeData);

      promiseData.preventAction = (callback) => {
        return Promise.resolve({ preventPromiseAction : true, data : callback(storeData) });
      };

      return promiseData;
    }

    const stringParams = params && pipe(toPairs,map(join("=")),join("&"))(params);
    
    this.store[method+path] = this.store[method+path] || {};
    let request;
    if (contextId && Array.isArray(contextId)) {
      request = ()=> {
        let promises = {};
        contextId.forEach((contextId) => {
          promises[contextId] = this.query(method, contextId, path, stringParams, body, headers);
        });

        return Promise.props(promises);
      }

    }
    request = request || ((params) => {
      const newStringParams = (params && pipe(toPairs,map(join("=")),join("&"))(params)) || stringParams;
      return this.query(method, contextId, path, newStringParams, body, headers);
    });

    return store ? store({params, contextId, request, store : this.store[method+path]}) : request();  
  }
}

class QueryServiceBuscador extends QueryService {
  constructor() {
    super();
    this.baseUrl =
      window.location.hostname !== 'localhost'
        ? window.location.protocol + '//' + window.location.host
        : 'https://www.eurostarshotels.com';
  }

  query(method, hotel, path, params) {
    const currentConfig = {
      headers: new Headers({
        Connection: 'keep-alive',
        Accept: 'application/json, text/plain, */*',
        //"Authorization": "Basic YmlnYm9zc0BpZ213ZWIuY29tOlM3Y2NEaVhTNFlBVDBkeUR6bmkyZGM4OGQzVEJWVzFsakJjajdSVHNfNDF2M3d6c3NkdEhHZTlLMk1LSEEtOWFacnRxSEQ0X0Jxd3BldDR0RHhSWmhB",
        'Accept-Language': lang,
        'Accept-Encoding': 'gzip, deflate'
      }),
      //mode: 'no-cors',
      cache: 'default',
      method: 'GET'
    };
    currentConfig.method = method;
    const url = new URL(path + (params ? '?' + params : ''), this.baseUrl);

    return new Promise((resolve, reject) => {
      fetch(url, currentConfig)
        .then(response => {
          resolve(response.json());
        })
        .catch(err => {
          reject(Error(err));
        });
    });
  }
}

class QueryServiceForm extends QueryService {
  constructor(source) {
    super();

    this.baseUrl = source || window.location;

  }

  post(body, params, path = null, headers = null) {
    return this.query('POST', null,path, params, body, headers);
  }

  query(method, hotel, path, params = null, body = null, headers = null) {

    const url = new URL(path ? path : ""+ (params ? '?' + params : ''), this.baseUrl);

    let form = document.createElement("form");
    form.method = method;
    form.action = url;
    form.target = "_self";
    form.hidden = true;
    forEachObjIndexed((value, key)=>{
      const input = document.createElement('input');
      input.type = "text";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }, body);

    document.body.append(form);
    form.submit();
    form.remove();

  }
}

class QueryServicePCI extends QueryService {
  constructor() {
    super();
    this.baseUrl = 'https://secure.booking-channel.com';
  }

  query(method, path, params, body = null, headers = null) {
    const currentConfig = {
      headers: new Headers({
        Connection: 'keep-alive',
        Accept: 'application/json, text/plain, */*',
        'Accept-Language': lang,
        'Accept-Encoding': 'gzip, deflate'
      }),
      //mode: 'no-cors',
      cache: 'default',
      method: 'GET'
    };
    headers &&
    headers.length > 0 &&
    headers.forEach(header => {
      const key = Object.keys(header)[0];
      currentConfig.headers.set(key, header[key]);
    });

    if (params) {
      let stringParams = [];
      forEachObjIndexed((query, key) => {
        stringParams.push(key + '=' + query);
      }, params);
      params = stringParams.join('&');
    }
    if (body) {
      currentConfig.body = JSON.stringify(body);
    }

    currentConfig.method = method;
    const url = new URL(path + (params ? '?' + params : ''), this.baseUrl);

    return new Promise((resolve, reject) => {
      fetch(url, currentConfig)
        .then(response => {
          if (response.ok) {
            resolve(response.json());
          } else {
            resolve({ success: response.ok, code: response.code });
          }
        })
        .catch(err => {
          reject({ success: false });
        });
    });
  }
}

let queryObjBuscador = {},
 queryObj = {};


export const apiGetter = (source, type) => {
  setHeaderLang((window.frontLoader && window.frontLoader.lang_info?.code ) || (window.lang_info && window.lang_info.code) || 'es');
  if (source === 'buscador') {
    return queryObjBuscador[window.location]
      ? queryObjBuscador[window.location]
      : (queryObjBuscador[window.location] = new QueryServiceBuscador());
  } else if (source === 'pci') {
    return queryObjBuscador['pci']
      ? queryObjBuscador['pci']
      : (queryObjBuscador['pci'] = new QueryServicePCI());
  } else if (type === "form") {
    return queryObj[type+source] ? queryObj[type+source] : (queryObj[type+source] = new QueryServiceForm(source));
  } else if (source) {
      return queryObj[source] ? queryObj[source] : (queryObj[source] = new QueryService(source));
  } else {
    return queryObj["hotels"] ? queryObj["hotels"] : (queryObj["hotels"] = new QueryService());
  }
};

export default apiGetter();
